// function showCustomPopup(message) {
//     return new Promise((resolve) => {
//         const popup = document.getElementById('cart-warning-popup') || createPopup();
//         const messageElement = popup.querySelector('#popup-message');
//         const cancelBtn = popup.querySelector('#popup-cancel');
//         const confirmBtn = popup.querySelector('#popup-confirm');

//         messageElement.textContent = message;
//         popup.style.display = 'flex';

//         const cleanup = () => {
//             popup.style.display = 'none';
//             cancelBtn.removeEventListener('click', handleCancel);
//             confirmBtn.removeEventListener('click', handleConfirm);
//         };

//         const handleCancel = () => {
//             cleanup();
//             resolve(false);
//         };

//         const handleConfirm = () => {
//             cleanup();
//             resolve(true);
//         };

//         cancelBtn.addEventListener('click', handleCancel);
//         confirmBtn.addEventListener('click', handleConfirm);
//     });
// }

// function createPopup() {
//     const popup = document.createElement('div');
//     popup.className = 'popup-overlay';
//     popup.id = 'cart-warning-popup';
//     popup.innerHTML = `
//       <div class="popup-content">
//         <p id="popup-message"></p>
//         <div class="popup-buttons">
//           <button id="popup-cancel" class="btn btn-secondary">Cancel</button>
//           <button id="popup-confirm" class="btn btn-primary">Confirm</button>
//         </div>
//       </div>
//     `;
//     document.body.appendChild(popup);
//     return popup;
// }

// function updateProductCount() {
//     const productCountElement = document.getElementById("ProductCount");
//     const visibleProducts = document.querySelectorAll('.collection_item');

//     if (productCountElement) {
//         productCountElement.textContent = `(${visibleProducts.length} products)`;
//     }
// }

// function filterProducts() {
//     updateProductCount();
// }

// async function getCartItemCount() {
//     try {
//         const response = await fetch('/cart.js');
//         const cart = await response.json();
//         return cart.item_count;
//     } catch (error) {
//         console.error('Error fetching cart:', error);
//         return 0;
//     }
// }

// async function clearCart() {
//     try {
//         await fetch('/cart/clear.js', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });
//         return true;
//     } catch (error) {
//         console.error('Error clearing cart:', error);
//         return false;
//     }
// }

// // Intercept AJAX calls to update product count
// function setupAjaxListener() {
//     // Override fetch to detect AJAX calls (Shopify often uses fetch for AJAX)
//     const originalFetch = window.fetch;
//     window.fetch = async function(url, options) {
//         const response = await originalFetch.apply(this, arguments);
        
//         // Check if the URL is related to product filtering/sorting
//         if (url.includes('/collections/') || url.includes('/search') || url.includes('sort_by')) {
//             // Clone the response to avoid consuming it
//             const clonedResponse = response.clone();
//             clonedResponse.text().then(() => {
//                 // Delay slightly to ensure DOM updates are complete
//                 setTimeout(updateProductCount, 100);
//             });
//         }
//         return response;
//     };

//     // Listen for Shopify-specific AJAX events (if applicable)
//     document.addEventListener('ajax:complete', () => {
//         setTimeout(updateProductCount, 100); // Delay to allow DOM to settle
//     });
// }

// async function ensureCityAttribute() {
//     try {
//         const response = await fetch('/cart.js');
//         const cart = await response.json();
//         if (!cart.attributes || !cart.attributes.city) {
//             // Find the Dubai option in the city selector
//             const citySelector = document.getElementById('city-selector');
//             let defaultCity = 'Dubai';
//             let defaultFlag = '';

//             if (citySelector) {
//                 const dubaiOption = Array.from(citySelector.options).find(
//                     option => option.value.toLowerCase() === 'dubai'
//                 );
//                 if (dubaiOption) {
//                     defaultCity = dubaiOption.value;
//                     defaultFlag = dubaiOption.getAttribute('data-flag');
//                 } else {
//                     // Fallback to first option if Dubai is not found
//                     defaultCity = citySelector.options[0].value;
//                     defaultFlag = citySelector.options[0].getAttribute('data-flag');
//                 }
//             }

//             // Update cart attributes
//             const formData = new FormData();
//             formData.append('attributes[city]', defaultCity);
//             formData.append('attributes[city_flag]', defaultFlag);

//             const updateResponse = await fetch('/cart/update.js', {
//                 method: 'POST',
//                 body: formData
//             });

//             if (!updateResponse.ok) {
//                 throw new Error('Failed to set default city');
//             }

//             // Update UI
//             if (citySelector) {
//                 citySelector.value = defaultCity;
//             }
//             const selectedFlag = document.getElementById('selected-city-flag');
//             if (selectedFlag && defaultFlag) {
//                 selectedFlag.src = defaultFlag;
//                 selectedFlag.alt = defaultCity;
//             }
//             const locationName = document.querySelector('.location-name');
//             if (locationName) {
//                 locationName.textContent = defaultCity;
//             }
//         }
//     } catch (error) {
//         console.error('Error ensuring city attribute:', error);
//     }
// }

// document.addEventListener('DOMContentLoaded', () => {
//     const form = document.getElementById('city-selector-form');
//     const citySelector = document.getElementById('city-selector');
//     const selectedFlag = document.getElementById('selected-city-flag');
//     const selectedLocation = document.querySelector('.selected-location');
//     const locationSelector = document.querySelector('.location-selector');
//     const locationDropdown = document.querySelector('.location-dropdown');
//     const locationOptions = document.querySelectorAll('.location-option');
//     let currentCity = citySelector ? citySelector.value : 'Dubai';

//     // Ensure city attribute is set on page load
//     ensureCityAttribute();

//     function setInitialCityFlag() {
//         if (citySelector && selectedFlag) {
//             const selectedOption = citySelector.options[citySelector.selectedIndex];
//             const savedFlag = selectedOption.getAttribute('data-flag');
//             if (savedFlag && selectedFlag.src !== savedFlag) {
//                 selectedFlag.src = savedFlag;
//                 selectedFlag.alt = selectedOption.value;
//             }
//         }
//     }

//     if (selectedLocation) {
//         selectedLocation.addEventListener('click', () => {
//             const isExpanded = locationSelector.getAttribute('aria-expanded') === 'true';
//             locationSelector.setAttribute('aria-expanded', !isExpanded);
//         });
//     }

//     if (locationOptions) {
//         locationOptions.forEach(option => {
//             option.addEventListener('click', async (e) => {
//                 const newCity = option.getAttribute('data-value');
//                 const newFlagUrl = option.getAttribute('data-flag');

//                 const itemCount = await getCartItemCount();
//                 if (itemCount > 0) {
//                     const message =
//                         `You have ${itemCount} item(s) in your cart. ` +
//                         `Changing the emirate will remove all items from your cart. ` +
//                         `Do you want to proceed?`;
//                     const confirmed = await showCustomPopup(message);

//                     if (!confirmed) {
//                         return;
//                     }

//                     const cleared = await clearCart();
//                     if (!cleared) {
//                         alert('Error clearing cart. Please try again.');
//                         return;
//                     }
//                 }

//                 if (citySelector) {
//                     citySelector.value = newCity;
//                 }
//                 if (selectedFlag) {
//                     selectedFlag.src = newFlagUrl;
//                     selectedFlag.alt = newCity;
//                 }
//                 const locationName = document.querySelector('.location-name');
//                 if (locationName) {
//                     locationName.textContent = newCity;
//                 }
//                 currentCity = newCity;
//                 if (locationSelector) {
//                     locationSelector.setAttribute('aria-expanded', 'false');
//                 }

//                 const formData = new FormData(form);
//                 formData.append('attributes[city_flag]', newFlagUrl);

//                 try {
//                     const response = await fetch('/cart/update.js', {
//                         method: 'POST',
//                         body: formData
//                     });

//                     if (response.ok) {
//                         window.location.href = '/';
//                     } else {
//                         throw new Error('Failed to update cart');
//                     }
//                 } catch (error) {
//                     console.error('Error updating cart:', error);
//                     alert('Error updating city selection. Please try again.');
//                 }
//             });
//         });

//         // locationOptions.forEach(option => {
//         //     option.addEventListener('click', async (e) => {
//         //         const newCity = option.getAttribute('data-value');
//         //         const newFlagUrl = option.getAttribute('data-flag');
        
//         //         // Check if the selected city is the same as the current city
//         //         if (newCity === currentCity) {
//         //             // Close the dropdown and do nothing if the same city is selected
//         //             if (locationSelector) {
//         //                 locationSelector.setAttribute('aria-expanded', 'false');
//         //             }
//         //             return;
//         //         }
        
//         //         const itemCount = await getCartItemCount();
//         //         if (itemCount > 0) {
//         //             const message =
//         //                 `You have ${itemCount} item(s) in your cart. ` +
//         //                 `Changing the emirate will remove all items from your cart. ` +
//         //                 `Do you want to proceed?`;
//         //             const confirmed = await showCustomPopup(message);
        
//         //             if (!confirmed) {
//         //                 return;
//         //             }
        
//         //             const cleared = await clearCart();
//         //             if (!cleared) {
//         //                 alert('Error clearing cart. Please try again.');
//         //                 return;
//         //             }
//         //         }
        
//         //         if (citySelector) {
//         //             citySelector.value = newCity;
//         //         }
//         //         if (selectedFlag) {
//         //             selectedFlag.src = newFlagUrl;
//         //             selectedFlag.alt = newCity;
//         //         }
//         //         const locationName = document.querySelector('.location-name');
//         //         if (locationName) {
//         //             locationName.textContent = newCity;
//         //         }
//         //         currentCity = newCity;
//         //         if (locationSelector) {
//         //             locationSelector.setAttribute('aria-expanded', 'false');
//         //         }
        
//         //         const formData = new FormData(form);
//         //         formData.append('attributes[city_flag]', newFlagUrl);
        
//         //         try {
//         //             const response = await fetch('/cart/update.js', {
//         //                 method: 'POST',
//         //                 body: formData
//         //             });
        
//         //             if (response.ok) {
//         //                 window.location.href = '/';
//         //             } else {
//         //                 throw new Error('Failed to update cart');
//         //             }
//         //         } catch (error) {
//         //             console.error('Error updating cart:', error);
//         //             alert('Error updating city selection. Please try again.');
//         //         }
//         //     });
//         // });
//     }

//     const productGrid = document.getElementById('product-grid');
//     if (productGrid) {
//         const observer = new MutationObserver(updateProductCount);
//         observer.observe(productGrid, { childList: true, subtree: true });
//     }

//     document.addEventListener('click', (e) => {
//         const isClickInside = (locationSelector && locationSelector.contains(e.target)) || (locationDropdown && locationDropdown.contains(e.target));
//         if (!isClickInside && locationSelector && locationSelector.getAttribute('aria-expanded') === 'true') {
//             locationSelector.setAttribute('aria-expanded', 'false');
//         }
//     });

//     // Initialize product count and listeners
//     updateProductCount();
//     setInitialCityFlag();
//     setupAjaxListener();
// });

function showCustomPopup(message) {
    return new Promise((resolve) => {
        const popup = document.getElementById('cart-warning-popup') || createPopup();
        const messageElement = popup.querySelector('#popup-message');
        const cancelBtn = popup.querySelector('#popup-cancel');
        const confirmBtn = popup.querySelector('#popup-confirm');

        messageElement.textContent = message;
        popup.style.display = 'flex';

        const cleanup = () => {
            popup.style.display = 'none';
            cancelBtn.removeEventListener('click', handleCancel);
            confirmBtn.removeEventListener('click', handleConfirm);
        };

        const handleCancel = () => {
            cleanup();
            resolve(false);
        };

        const handleConfirm = () => {
            cleanup();
            resolve(true);
        };

        cancelBtn.addEventListener('click', handleCancel);
        confirmBtn.addEventListener('click', handleConfirm);
    });
}

function createPopup() {
    const popup = document.createElement('div');
    popup.className = 'popup-overlay';
    popup.id = 'cart-warning-popup';
    popup.innerHTML = `
      <div class="popup-content">
        <p id="popup-message"></p>
        <div class="popup-buttons">
          <button id="popup-cancel" class="btn btn-secondary">Cancel</button>
          <button id="popup-confirm" class="btn btn-primary">Confirm</button>
        </div>
      </div>
    `;
    document.body.appendChild(popup);
    return popup;
}

function updateProductCount() {
    // const productCountElement = document.getElementById("ProductCount");
    // const visibleProducts = document.querySelectorAll('.collection_item');

    // if (productCountElement) {
    //     productCountElement.textContent = `(${visibleProducts.length} products)`;
    // }
}

function filterProducts() {
    updateProductCount();
}

async function getCartItemCount() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        return cart.item_count;
    } catch (error) {
        console.error('Error fetching cart:', error);
        return 0;
    }
}

async function clearCart() {
    try {
        await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return true;
    } catch (error) {
        console.error('Error clearing cart:', error);
        return false;
    }
}

// Intercept AJAX calls to update product count
function setupAjaxListener() {
    // Override fetch to detect AJAX calls (Shopify often uses fetch for AJAX)
    const originalFetch = window.fetch;
    window.fetch = async function(url, options) {
        const response = await originalFetch.apply(this, arguments);
        
        // Check if the URL is related to product filtering/sorting
        if (url.includes('/collections/') || url.includes('/search') || url.includes('sort_by')) {
            // Clone the response to avoid consuming it
            const clonedResponse = response.clone();
            clonedResponse.text().then(() => {
                // Delay slightly to ensure DOM updates are complete
                setTimeout(updateProductCount, 100);
            });
        }
        return response;
    };

    // Listen for Shopify-specific AJAX events (if applicable)
    document.addEventListener('ajax:complete', () => {
        setTimeout(updateProductCount, 100); // Delay to allow DOM to settle
    });
}

async function ensureCityAttribute() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        if (!cart.attributes || !cart.attributes.city) {
            // Find the Dubai option in the city selector
            const citySelector = document.getElementById('city-selector');
            let defaultCity = "Dubai"; // fallback

const path = window.location.pathname.toLowerCase();

if (path.includes("sharjah")) {
  defaultCity = "Sharjah";
} else if (path.includes("ajman")) {
  defaultCity = "Ajman";
}
else if (path.includes("abu-dhabi")) {
  defaultCity = "Abu Dhabi";
}

            let defaultFlag = '';

            if (citySelector) {
  // Try to find the option matching the chosen city
  const matchedOption = Array.from(citySelector.options).find(
    option => option.value.toLowerCase() === defaultCity.toLowerCase()
  );

  if (matchedOption) {
    // ✅ Use Sharjah/Ajman if matched
    defaultCity = matchedOption.value;
    defaultFlag = matchedOption.getAttribute("data-flag");
  } else {
    // Fallback to Dubai if match not found
    const dubaiOption = Array.from(citySelector.options).find(
      option => option.value.toLowerCase() === "dubai"
    );
    if (dubaiOption) {
      defaultCity = dubaiOption.value;
      defaultFlag = dubaiOption.getAttribute("data-flag");
    } else {
      defaultCity = citySelector.options[0].value;
      defaultFlag = citySelector.options[0].getAttribute("data-flag");
    }
  }
}



            // Update cart attributes
            const formData = new FormData();
            formData.append('attributes[city]', defaultCity);
            formData.append('attributes[city_flag]', defaultFlag);

            const updateResponse = await fetch('/cart/update.js', {
                method: 'POST',
                body: formData
            });

            if (!updateResponse.ok) {
                throw new Error('Failed to set default city');
            }

            // Update UI
            if (citySelector) {
                citySelector.value = defaultCity;
            }
            const selectedFlag = document.getElementById('selected-city-flag');
            if (selectedFlag && defaultFlag) {
                selectedFlag.src = defaultFlag;
                selectedFlag.alt = defaultCity;
            }
            const locationName = document.querySelector('.location-name');
            if (locationName) {
                locationName.textContent = defaultCity;
            }
        }
    } catch (error) {
        console.error('Error ensuring city attribute:', error);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('city-selector-form');
    const citySelector = document.getElementById('city-selector');
    const selectedFlag = document.getElementById('selected-city-flag');
    const selectedLocation = document.querySelector('.selected-location');
    const locationSelector = document.querySelector('.location-selector');
    const locationDropdown = document.querySelector('.location-dropdown');
    const locationOptions = document.querySelectorAll('.location-option');
    let currentCity = citySelector ? citySelector.value : 'Dubai';

    // Ensure city attribute is set on page load
    ensureCityAttribute();

    function setInitialCityFlag() {
        if (citySelector && selectedFlag) {
            const selectedOption = citySelector.options[citySelector.selectedIndex];
            const savedFlag = selectedOption.getAttribute('data-flag');
            if (savedFlag && selectedFlag.src !== savedFlag) {
                selectedFlag.src = savedFlag;
                selectedFlag.alt = selectedOption.value;
            }
        }
    }

    if (selectedLocation) {
        selectedLocation.addEventListener('click', () => {
            const isExpanded = locationSelector.getAttribute('aria-expanded') === 'true';
            locationSelector.setAttribute('aria-expanded', !isExpanded);
        });
    }

    locationOptions.forEach(option => {
        option.addEventListener('click', async (e) => {
            const newCity = option.getAttribute('data-value');
            const newFlagUrl = option.getAttribute('data-flag');

            //   Check if the selected city is the same as the current city
            if (newCity === currentCity) {
                //   Close the dropdown and do nothing if the same city is selected
                if (locationSelector) {
                    locationSelector.setAttribute('aria-expanded', 'false');
                }
                return;
            }

            const itemCount = await getCartItemCount();
            if (itemCount > 0) {
                const message =
                    `You have ${itemCount} item(s) in your cart. ` +
                    `Changing the emirate will remove all items from your cart. ` +
                    `Do you want to proceed?`;
                const confirmed = await showCustomPopup(message);

                if (!confirmed) {
                    return;
                }

                const cleared = await clearCart();
                if (!cleared) {
                    alert('Error clearing cart. Please try again.');
                    return;
                }
            }

            if (citySelector) {
                citySelector.value = newCity;
            }
            if (selectedFlag) {
                selectedFlag.src = newFlagUrl;
                selectedFlag.alt = newCity;
            }
            const locationName = document.querySelector('.location-name');
            if (locationName) {
                locationName.textContent = newCity;
            }
            currentCity = newCity;
            if (locationSelector) {
                locationSelector.setAttribute('aria-expanded', 'false');
            }

            const formData = new FormData(form);
            formData.append('attributes[city_flag]', newFlagUrl);

            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    // window.location.href = '/';
                    
                    if (window.location.pathname.includes("product")) {
                        window.location.href = '/'
                    }
                    else {
                        window.location.reload();
                    }
                } else {
                    throw new Error('Failed to update cart');
                }
            } catch (error) {
                console.error('Error updating cart:', error);
                alert('Error updating city selection. Please try again.');
            }
        });
    })

    const productGrid = document.getElementById('product-grid');
    if (productGrid) {
        const observer = new MutationObserver(updateProductCount);
        observer.observe(productGrid, { childList: true, subtree: true });
    }

    document.addEventListener('click', (e) => {
        const isClickInside = (locationSelector && locationSelector.contains(e.target)) || (locationDropdown && locationDropdown.contains(e.target));
        if (!isClickInside && locationSelector && locationSelector.getAttribute('aria-expanded') === 'true') {
            locationSelector.setAttribute('aria-expanded', 'false');
        }
    });

    // Initialize product count and listeners
    updateProductCount();
    setInitialCityFlag();
    setupAjaxListener();
});


(function () {
    function getGSTDate() {
      const now = new Date();
      const utc = now.getTime() + now.getTimezoneOffset() * 60000;
      const gstTime = new Date(utc + (4 * 60 * 60 * 1000)); // GST is UTC+4
      return gstTime;
    }

    function setEarliestDelivery() {
      const gstTime = getGSTDate();
      const hour = gstTime.getHours();
      const deliveryDate = (hour >= 21 && hour < 24) ? "Tomorrow" : "Today";
      
      // Update all existing .custom-delivery-date elements
      document.querySelectorAll(".custom-delivery-date").forEach(el => {
        el.textContent = deliveryDate;
      });
    }

    // Function to initialize the MutationObserver
    function setupMutationObserver() {
      // Select the container that holds the product cards (adjust selector as needed)
      const targetNode = document.querySelector('.collection__products') || document.body;

      // MutationObserver configuration
      const config = {
        childList: true, // Observe additions/removals of child elements
        subtree: true // Observe descendants
      };

      // Callback function for when mutations are observed
      const callback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // Check for newly added .custom-delivery-date elements
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const deliveryElements = node.classList.contains('custom-delivery-date')
                  ? [node]
                  : node.querySelectorAll('.custom-delivery-date');
                
                if (deliveryElements.length > 0) {
                  setEarliestDelivery(); // Update delivery text for new elements
                }
              }
            });
          }
        }
      };

      // Create and start the observer
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);

      // Clean up observer on page unload (optional, to prevent memory leaks)
      window.addEventListener('unload', () => {
        observer.disconnect();
      });
    }

    // Expose setEarliestDelivery globally (if needed for other scripts)
    window.setEarliestDelivery = setEarliestDelivery;

    // Run initial setup
    document.addEventListener("DOMContentLoaded", () => {
      setEarliestDelivery(); // Set initial delivery text
      setupMutationObserver(); // Start observing DOM changes
    });
})();